import { Box } from '@mui/material';

import { Button } from '@occc/ui-design-system';

type TransactionsFilterFormActionsProps = {
  onReset: () => void;
};

export const TransactionsFilterFormActions = ({ onReset }: TransactionsFilterFormActionsProps) => {
  return (
    <Box display='flex' justifyContent='flex-end' px={3} py={2}>
      <Button size='small' color='error' onClick={onReset}>
        reset
      </Button>
      <Button type='submit' size='small' color='primary'>
        apply
      </Button>
    </Box>
  );
};
